import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const serviceType = createApi({
    reducerPath: "serviceType",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("Authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getServiceType: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/subcategoryType?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addServiceType: builder.mutation({
            query: (body) => ({
                url: "/subcategoryType",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateServiceType: builder.mutation({
            query: ({ id, body }) => ({
                url: `/subcategoryType/${id}`,
                method: "PUT",
                body,

            }),
        }),

        // ✅ Delete Category
        deleteServiceType: builder.mutation({
            query: (id) => ({
                url: `/subcategoryType/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetServiceTypeQuery,
    useAddServiceTypeMutation,
    useUpdateServiceTypeMutation,
    useDeleteServiceTypeMutation
} = serviceType;
